import * as React from 'react';

export default class noComments extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
    

<svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="305" height="213" viewBox="0 0 305 213">
    <g fill="none" fillRule="evenodd">
        <path d="M1 58H1367V769H1z" transform="translate(-561 -236)"/>
        <g>
            <g>
                <path fill="#FFF" d="M38.366 0s35.936 15.171 67.686 9.652c0 0 .856 18.91-24.949 19.887-6.38.242-13.84-.068-24.963-4.007 0 0-11.992 20.647-37.865 21.208-5.475.12-11.12-.216-18.275-3.088 0 0 23.772-18.298 38.366-43.652z" transform="translate(-561 -236) translate(558 236) translate(201)"/>
                <path fill="#F1F5F6" d="M56.14 25.532s40.06 16.847 50.231-15.67c0 0-.316 11.324-13.195 19.834C71.184 44.226 41.238 57.463.068 43.824c0 0 32.273 13.772 56.072-18.292z" transform="translate(-561 -236) translate(558 236) translate(201)"/>
            </g>
            <g>
                <path fill="#FFF" d="M22.073 0s20.674 8.76 38.941 5.573c0 0 .492 10.919-14.354 11.483-3.67.14-7.962-.04-14.361-2.314 0 0-6.9 11.922-21.785 12.246-3.15.069-6.397-.124-10.514-1.783C0 25.205 13.676 14.64 22.073 0z" transform="translate(-561 -236) translate(558 236) translate(0 81)"/>
                <path fill="#F1F5F6" d="M32.703 15.084S56.068 24.852 62 6c0 0-.184 6.565-7.696 11.499C41.477 25.923 24.012 33.596 0 25.689c0 0 18.823 7.984 32.703-10.605z" transform="translate(-561 -236) translate(558 236) translate(0 81)"/>
            </g>
            <path fill="#F1F5F6" d="M72.515 101.29L72 211.045 245.056 212 246 101z" transform="translate(-561 -236) translate(558 236)"/>
            <path fill="#F1F5F6" d="M72 102L158.018 27 246 101.708z" transform="translate(-561 -236) translate(558 236)"/>
            <path fill="#EAEFF0" d="M73 102L247 102.312 162.621 167z" transform="translate(-561 -236) translate(558 236)"/>
            <path fill="#FEFEFE" d="M162.312 166L218.853 122.951 219 81 99.047 81 99 120.184z" transform="translate(-561 -236) translate(558 236)"/>
            <path fill="#EAEFF0" d="M153.557 100h-26.113c-.797 0-1.444-.672-1.444-1.5s.647-1.5 1.444-1.5h26.113c.797 0 1.443.672 1.443 1.5s-.646 1.5-1.443 1.5M166.552 110h-39.103c-.8 0-1.449-.672-1.449-1.5s.649-1.5 1.45-1.5h39.102c.8 0 1.448.672 1.448 1.5s-.649 1.5-1.448 1.5M179.575 119h-51.15c-.786 0-1.425-.672-1.425-1.5s.64-1.5 1.426-1.5h51.15c.786 0 1.424.672 1.424 1.5s-.638 1.5-1.425 1.5M199.57 129h-71.138c-.79 0-1.432-.672-1.432-1.5s.642-1.5 1.432-1.5h71.137c.79 0 1.431.672 1.431 1.5s-.64 1.5-1.43 1.5" transform="translate(-561 -236) translate(558 236)"/>
        </g>
    </g>
</svg>


    );
  }
}
